import React from 'react'

import Markdown from '../../markdown'
import * as Types from '../../types'

const article: Types.Article = {
  title: 'Just how far can I take spaced-repetition: an experiment.',
  url: 'srs-conjugation',
  date: new Date('May 19 2025').getTime(),
  feedContent: (
    <Markdown>{`
    *If you want to try this approach yourself, check out the app: [grsly](https://grsly.com/)*
      
    After great success using anki for learning Japanese vocab, I wondered if I could apply the same techniques to conjugation, a particularly challenging area for me. Of course this has been done before. However, all decks I've found have a significant limitation: the number of examples. I'd just end up memorizing the examples for each conjugation category, but wouldn't understand them well enough to reliably recognize or produce conjugations (other than those few examples) in real life contexts.

    So then, I'm thinking, what would it take to have separate cards for all of them? N3 includes ~450 verbs, and I'd be shooting for ~200 conjugations (high number due to counting 'ichidan past' separately from 'godan mu past', separately from 'iku past' etc). That's ~90k combinations, even taking into account that not all verbs make sense with all forms it's way too many. Plus, it would be massive overkill and a waste of time since they follow patterns anyway.

    Okay, what if instead I have one card for each of the 200 conjugations, and just show a different example every time (using a verb I already know). Would my accuracy suffer? Would I need to do an unreasonable number of reviews? Would I actually learn the patterns intuitively? Only one way to find out.    
`}</Markdown>
  ),
  tags: [],
  loadContent: () => import('./content'),
}

export default article
